// import React, { useRef, useState } from "react";
// import { Button, Checkbox } from "@mui/material";
// import "react-datepicker/dist/react-datepicker.css";
// import "react-toastify/dist/ReactToastify.css";
// import TopTitleFormComponent from "./TopTitleFormComponent";
// import { getDoc, doc } from "firebase/firestore";
// import { useEffect } from "react";
// import { db } from "../../firebase";
// import ReactToPrint from "react-to-print";

// function ViewTreatmentEngagementPolicy(props) {
//   const [signaturePic, setSignaturePic] = useState(null);
//   const [text1, setText1] = useState("");
//   const [text2, setText2] = useState("");
//   const [text3, setText3] = useState("");
//   const [text4, setText4] = useState("");
//   const [text5, setText5] = useState("");
//   const [text6, setText6] = useState("");
//   const [text7, setText7] = useState("");
//   const printRef = useRef();

//   function formatDate(timestamp) {
//     const date = timestamp.toDate();
//     const day = date.getDate().toString().padStart(2, "0");
//     const monthNames = [
//       "January",
//       "February",
//       "March",
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//     ];
//     const month = monthNames[date.getMonth()];
//     const year = date.getFullYear();
//     const hours = date.getHours().toString().padStart(2, "0");
//     const minutes = date.getMinutes().toString().padStart(2, "0");
//     const timeZone = date
//       .toLocaleString("en", { timeZoneName: "short" })
//       .split(" ")
//       .pop();

//     return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
//   }

//   const fetchSignatureUrl = async () => {
//     const docRef = doc(db, "TreatmentEngagementForm", props.clientId);
//     const docSnap = await getDoc(docRef);

//     if (docSnap.exists()) {
//       const data = docSnap.data();
//       const signatureUrl = data.signatureURL;
//       setSignaturePic(signatureUrl);

//       setText1(data.text1);
//       setText2(data.text2);
//       setText3(data.text3);
//       setText4(data.text4);
//       setText5(data.text5);
//       setText6(data.text6);
//       setText7(data.text7);
//     } else {
//     }
//   };

//   useEffect(() => {
//     fetchSignatureUrl();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <>
//       <style>
//         {`
//           @media print {
//             #printableContent {
//               height: auto !important;
//               overflow-y: visible !important;
//             }
//           }
//         `}
//       </style>

//       <div style={{ width: "auto", height: "100%" }}>
//         <div className="line1-modal-percent">
//           <TopTitleFormComponent
//             title="TREATMENT PROGRAMME ENGAGEMENT POLICY FORM"
//             closemodal={props.closemodal}
//           />
//         </div>

//         <div
//           id="printableContent"
//           style={{
//             width: "100%",
//             marginTop: "10px",
//             height: "80%",
//             overflowY: "scroll",
//             // overflowX: "hidden",
//           }}
//           ref={printRef}
//           // style={{ marginTop: "60px", height: "500px", overflowY: "scroll" }}
//           // style={{ marginTop: "60px", height: "auto", overflowY: "scroll" }}
//         >
//           <div className="client-name-container">
//             Treatment programme engagement policy form for: {props.firstName}{" "}
//             {props.lastName}
//           </div>
//           <br />

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text1}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text2}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text3}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text4}</div>
//           </div>

//           {/* <div className="SubTitleBold">Incident reports:</div> */}

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text5}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text6}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={true} />
//             <div className="block-text-check">{text7}</div>
//           </div>

//           <div className="signature-date-container">
//             <div className="text-block-2">
//               Timestamp signature :{" "}
//               {formatDate(props.treatmentEngagementPolicyDateSigned)}{" "}
//             </div>
//             <div className="signature-title">
//               Client signature (
//               <span style={{ fontWeight: "bold" }}>
//                 {props.firstName} {props.lastName}
//               </span>
//               ):
//             </div>
//             <img
//               alt="Signature"
//               className="signature-pic-roi"
//               src={signaturePic}
//             />
//           </div>
//         </div>
//         <div className="line4-modal-percent-bis">
//           <>
//             <Button
//               variant="contained"
//               style={{ backgroundColor: "white", color: "black" }}
//               onClick={props.closemodal}
//             >
//               Cancel
//             </Button>

//             <ReactToPrint
//               trigger={() => (
//                 <Button variant="contained" style={{ marginLeft: "20px" }}>
//                   Print
//                 </Button>
//               )}
//               content={() => printRef.current}
//               onAfterPrint={props.closemodal}
//             />
//           </>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ViewTreatmentEngagementPolicy;

import React, { useRef, useState, useEffect } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";
import "./AdmissionDocumentRedesign.css";

function ViewTreatmentEngagementPolicy({
  clientId,
  firstName,
  lastName,
  treatmentEngagementPolicyDateSigned,
  closemodal,
}) {
  const [signaturePic, setSignaturePic] = useState(null);
  const [storedIls, setStoredIls] = useState(null);
  const printRef = useRef();

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.toDate) return "";
    const date = timestamp.toDate();
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();
    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  // const fetchData = async () => {
  //   const docRef = doc(db, "TreatmentEngagementForm", clientId);
  //   const docSnap = await getDoc(docRef);
  //   if (docSnap.exists()) {
  //     const data = docSnap.data();
  //     setSignaturePic(data.signatureURL || null);
  //     setStoredIls(data.intendedLengthOfStay ?? null);
  //   }
  // };

  const fetchData = async () => {
    const docRef = doc(db, "TreatmentEngagementForm", clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      setSignaturePic(data.signatureURL || null);

      // on privilégie intendedLengthOfStay, sinon on utilise durationOfStay
      const ilsValue =
        data.intendedLengthOfStay != null
          ? data.intendedLengthOfStay
          : data.durationOfStay != null
          ? data.durationOfStay
          : null;

      setStoredIls(ilsValue);
      console.log("data.intendedLengthOfStay: ", data.intendedLengthOfStay);
      console.log("data.durationOfStay: ", data.durationOfStay);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  console.log("storedIls: ", storedIls);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>

      <div className="admission-document-shell admission-card-form-shell treatment-engagement-form-shell">
        <TopTitleFormComponent
          title="Treatment programme engagement policy form"
          eyebrow="Admission form"
          subtitle={`${firstName || "Client"} ${lastName || ""}`.trim()}
          closemodal={closemodal}
        />

        <div
          id="printableContent"
          ref={printRef}
          style={{
            width: "100%",
            marginTop: 10,
            height: "80%",
            overflowY: "scroll",
            padding: "0 15px",
          }}
        >
          <div className="client-name-container">
            Treatment programme engagement policy form for:{" "}
            <strong>
              {firstName} {lastName}
            </strong>
          </div>
          <br />

          <div className="checkbox-container-margin">
            <Checkbox checked />
            <div className="block-text-check">
              I agree to attend all programme activities throughout my stay at
              Miracles Asia unless prior to the activity I am excused from that
              activity by:
              <ul className="nested-list">
                <li>a medical waiver</li>
                <li>if I am required to attend to an immigration issue</li>
                <li>
                  my primary therapist, the Clinical Director, or the Managing
                  Director
                </li>
              </ul>
            </div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked />
            <div className="block-text-check">
              I understand that not attending an activity without being excused
              may result in the following actions:
              <ul className="nested-list">
                <li>
                  Step 1: Verbal and/or written directive to attend all
                  subsequent activities
                </li>
                <li>
                  Step 2: Initiating a Behavioural Support Agreement created by
                  the clinical team
                </li>
                <li>
                  Step 3: A case-by-case review by the clinical team to
                  determine the next appropriate action
                </li>
              </ul>
            </div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked />
            <div className="block-text-check">
              I understand that my Intended Length of Stay as an in-house client
              will be <strong>{storedIls ?? "—"}</strong>
            </div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked />
            <div className="block-text-check">
              I understand that I am responsible for my recovery
            </div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked />
            <div className="block-text-check">
              I agree to participate in all aspects of my treatment and to
              follow the treatment plans provided to me by my therapists and
              doctors to the best of my ability
            </div>
          </div>

          <div className="signature-date-container">
            <div className="signature-title">
              Client name :{" "}
              <strong>
                {firstName} {lastName}
              </strong>{" "}
            </div>
            <div className="text-block-2">
              Timestamp signature:{" "}
              {formatDate(treatmentEngagementPolicyDateSigned)}
            </div>

            {signaturePic && (
              <img
                alt="Signature"
                className="signature-pic-roi"
                src={signaturePic}
              />
            )}
          </div>
        </div>

        <div className="line4-modal-percent-bis">
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={closemodal}
          >
            Cancel
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button variant="contained" style={{ marginLeft: 20 }}>
                Print
              </Button>
            )}
            content={() => printRef.current}
            onAfterPrint={closemodal}
          />
        </div>
      </div>
    </>
  );
}

export default ViewTreatmentEngagementPolicy;
